import React from 'react';
import { DataTableColumn, DataTableRow } from './types';
import { getAlign, getSize } from './utils';

const TableRow = ({
  columns,
  row,
  stickyFirstColumn = false,
  onRowClick,
}: {
  columns: DataTableColumn[],
  row: DataTableRow;
  stickyFirstColumn?: boolean;
  onRowClick?: (row: DataTableRow) => void;
}) => {

  const renderCell = (column: DataTableColumn) => {
    if (column.options?.render) {
      return column.options.render(row);
    }
    if (column.options?.renderLite) {
      return column.options.renderLite(row[column.key]);
    }
    return row[column.key];
  };

  const tdClassName = 'tw-py-2 tw-px-2 '
    + 'tw-border-b tw-border-x-0 tw-border-t-0 tw-border-gray-100 tw-border-solid '
    + 'first:tw-pl-4 last:tw-pr-4 first:tw-border-l last:tw-border-r '
    + (stickyFirstColumn ? 'first:tw-sticky first:tw-left-0 first:tw-z-10 first:tw-bg-white' : '');

  const handleRowClick = (e: React.MouseEvent<HTMLTableRowElement>) => {
    if (onRowClick) {
      const target = e.target as HTMLElement;
      if (target.closest('.ProfilePopover')) return;
      if (target.closest('.profile-link')) return;
      onRowClick(row);
    }
  };

  return (
    <tr
      className={`tw-table-row ${onRowClick ? 'tw-cursor-pointer hover:tw-bg-gray-50' : ''}`}
      onClick={handleRowClick}
    >
      {columns.map((column, index) => (
        <td
          className={`${tdClassName} ${column?.className || ''}`}
          // eslint-disable-next-line react/no-array-index-key
          key={`${column.key}-${index}`}
          style={{
            width: getSize(column?.options?.size, columns),
          }}
        >
          <div className={`tw-flex tw-flex-row tw-items-center tw-gap-2 ${getAlign(column.options?.align)}`}>
            {renderCell(column)}
          </div>
        </td>
      ))}
    </tr>
  );
};

export default TableRow;
